var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpView(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10403",
    "data-name": "Group 10403",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.25,
    height: 20,
    viewBox: "0 0 20.25 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3044",
    "data-name": "Rectangle 3044",
    width: 10.99,
    height: 12.694,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10401",
    "data-name": "Group 10401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10159",
    "data-name": "Group 10159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10055",
    "data-name": "Group 10055"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2970",
    "data-name": "Rectangle 2970",
    width: 20.25,
    height: 20,
    rx: 10,
    fill: "#4a90f7"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10402",
    "data-name": "Group 10402",
    transform: "translate(4.63 3.806)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10169",
    "data-name": "Group 10169",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3250",
    "data-name": "Path 3250",
    d: "M9.243,5.637c-.357-.183-.69-.338-1-.524a.389.389,0,0,1-.132-.292c-.009-1.1-.006-2.2-.006-3.3V1.145H1.185V9.807c.624,0,1.247.012,1.87-.006a.378.378,0,0,1,.427.279c.121.3.293.575.456.884-.969,0-1.922.036-2.87-.012A1.115,1.115,0,0,1,0,9.742Q0,5.473,0,1.2A1.15,1.15,0,0,1,1.2,0Q4.638,0,8.074,0a1.113,1.113,0,0,1,1.163,1.07c.016,1.519.005,3.038.005,4.565",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3251",
    "data-name": "Path 3251",
    d: "M71.684,100.564c-.424-.451-.877-.926-1.319-1.409a.321.321,0,0,0-.461-.079,2.763,2.763,0,0,1-3.114-.28,2.874,2.874,0,1,1,4.087-3.959,2.807,2.807,0,0,1,.259,2.991c-.042.092-.1.179-.143.268l1.615,1.569-.923.9m-3.123-5.78A1.747,1.747,0,1,0,70.3,96.532a1.776,1.776,0,0,0-1.742-1.749",
    transform: "translate(-61.617 -87.87)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpView);
export default __webpack_public_path__ + "static/media/op-view.57e3f27d4b158bb8d0723d4137636899.svg";
export { ForwardRef as ReactComponent };